<template>

  <div class="Rebate">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >
      <b-row>
        <b-col cols="12 headerF"><HeaderFixed/></b-col>
        <b-col cols="12 headerM"><HeaderMobile/></b-col>
      </b-row>
      <b-container id="circleSupplyDiv" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
            <b-breadcrumb style=" background-color: #e9ecef78;">
              <b-breadcrumb-item href="#home">
                <router-link to="/">
                  <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                  Home
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item>
                <router-link to="/EodbReport">
                  EODB Report
                </router-link>
              </b-breadcrumb-item>
              <b-breadcrumb-item href="#" active>Dashboard for Hourly Power Supply</b-breadcrumb-item>
            </b-breadcrumb>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <span class="title">Dashboard for Hourly Power Supply</span>
          </b-col>
        </b-row>
        <hr/>

        <div class="paddingLeft30px">
          <br>

          <b-row>
            <b-col cols="12" lg="2" md="3" class="alignAndPadding fieldLabel">
              Circle: <span class="reqStar">*</span>
            </b-col>
            <b-col cols="12" lg="3" md="3" class="dorpDownMarginTop">
              <b-form-select id="circleSelected" v-model="selectedCircle" :options="circleOptions" size="sm" class="mt-3"></b-form-select>
            </b-col>

            <b-col cols="12" lg="2" md="3" class="alignAndPadding fieldLabel">
              Year: <span class="reqStar">*</span>
            </b-col>
            <b-col cols="12" lg="3" md="3" class="dorpDownMarginTop">
              <b-form-select id="yearSelected" v-model="selectedYear" :options="yearOptions" :disabled="!selectedCircle" size="sm" class="mt-3"></b-form-select>
            </b-col>
          </b-row>

          <br>

          <b-row>
            <b-col cols="12" lg="2" md="3" class="alignAndPadding fieldLabel">
              Month: <span class="reqStar">*</span>
            </b-col>
            <b-col cols="12" lg="3" md="3" class="dorpDownMarginTop">
              <b-form-select id="monthSelected" v-model="selectedMonth" :options="monthOptions" :disabled="!selectedYear" size="sm" class="mt-3"></b-form-select>
            </b-col>

            <b-col v-if="activeTabIndex === 0" cols="12" lg="2" md="3" class="alignAndPadding fieldLabel">
              Week(s):
            </b-col>
            <b-col v-if="activeTabIndex === 0" cols="12" lg="5" md="6" class="dorpDownMarginTop">
              <b-form-checkbox-group
                id="weekSelected"
                v-model="selectedWeeks"
                :options="weekOptions"
                :disabled="!selectedMonth"
                class="mt-3 weekChecks"
              ></b-form-checkbox-group>
              <small class="text-muted">Optional — leave blank for the full month</small>
            </b-col>
          </b-row>

          <br>

          <b-tabs v-model="activeTabIndex" content-class="mt-3" card fill @activate-tab="onTabActivate">
            <b-tab title="Hourly Supply">
              <div v-if="hourlyLoaded">
                <b-table
                  v-if="hourlySupplyData.length"
                  bordered
                  responsive
                  striped
                  :items="hourlySupplyData"
                  :fields="hourlySupplyFieldsComputed"
                  class="text-center"
                ></b-table>
                <div v-else class="noData">
                  No data available for the selected Circle / Year / Month / Week.
                </div>
              </div>
              <div v-else class="noData">
                Select the required fields above and choose this tab to load Hourly Supply data.
              </div>
            </b-tab>

            <b-tab title="SAIDI / SAIFI">
              <div v-if="saidiSaifiLoaded">
                <b-table
                  v-if="saidiSaifiData.length"
                  bordered
                  responsive
                  striped
                  :items="saidiSaifiData"
                  :fields="saidiSaifiFields"
                  class="text-center"
                ></b-table>
                <div v-else class="noData">
                  No data available for the selected Circle / Year / Month.
                </div>
              </div>
              <div v-else class="noData">
                Select the required fields above and choose this tab to load SAIDI / SAIFI data.
              </div>
            </b-tab>
          </b-tabs>

        </div>

        <b-modal id="circleSupplyAlertModal" centered scrollable title="ALERT !" :static="true" hide-footer>
          <span class="data">{{ alertMsg }}</span>
          <br><br>
          <b-button style="width:8rem" variant="outline-primary" @click="$bvModal.hide('circleSupplyAlertModal')">OK</b-button>
        </b-modal>

      </b-container>

      <br><br>
    </b-overlay>

  </div>

</template>


<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)

var thColor = '#0288d1';

export default {
  name: 'EodbOutageSummary',
  components: {
    'HeaderFixed': HeaderFixed,
    'HeaderMobile': HeaderMobile
  },

  data() {

    var currentYear = new Date().getFullYear();
    var startYear = 2026;
    var yearOpts = [{ value: null, text: 'Please select a year' }];
    for (var y = startYear; y <= Math.max(currentYear, startYear); y++) {
      yearOpts.push({ value: y, text: String(y) });
    }

    return {
      show: false,
      alertMsg: '',

      activeTabIndex: 0,
      hourlyLoaded: false,
      saidiSaifiLoaded: false,

      selectedCircle: null,
      selectedYear: null,
      selectedMonth: null,
      selectedWeeks: [],

      circleOptions: [
        { value: null, text: 'Please select a circle' },
        { value: '17', text: 'Badarpur' },
        { value: '16', text: 'Barpeta' },
        { value: '03', text: 'Bongaigaon' },
        { value: '09', text: 'Cachar' },
        { value: '13', text: 'Dibrugarh' },
        { value: '01', text: 'GEC-I' },
        { value: '02', text: 'GEC-II' },
        { value: '18', text: 'Golaghat' },
        { value: '11', text: 'Jorhat' },
        { value: '10', text: 'KANCH' },
        { value: '04', text: 'Kokrajhar' },
        { value: '06', text: 'Mangaldoi' },
        { value: '19', text: 'Morigaon' },
        { value: '08', text: 'Nagaon' },
        { value: '14', text: 'North Lakhimpur' },
        { value: '05', text: 'Rangia' },
        { value: '12', text: 'Sivasagar' },
        { value: '07', text: 'Tezpur' },
        { value: '15', text: 'Tinsukia' }
      ],

      yearOptions: yearOpts,

      monthOptions: [
        { value: null, text: 'Please select a month' },
        { value: '01', text: 'January' },
        { value: '02', text: 'February' },
        { value: '03', text: 'March' },
        { value: '04', text: 'April' },
        { value: '05', text: 'May' },
        { value: '06', text: 'June' },
        { value: '07', text: 'July' },
        { value: '08', text: 'August' },
        { value: '09', text: 'September' },
        { value: '10', text: 'October' },
        { value: '11', text: 'November' },
        { value: '12', text: 'December' }
      ],

      weekOptions: [
        { text: 'Week 1', value: 'Week1' },
        { text: 'Week 2', value: 'Week2' },
        { text: 'Week 3', value: 'Week3' },
        { text: 'Week 4', value: 'Week4' },
        { text: 'Week 5', value: 'Week5' }
      ],

      hourlySupplyRaw: null,
      saidiSaifiRaw: null,

      saidiSaifiFields: [
        { key: 'circle', label: 'Circle', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'month', label: 'Month', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'saidi', label: 'SAIDI (mins)', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'saifi', label: 'SAIFI', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ]
    }
  },

  computed: {

    hourlySupplyData() {
      if (!this.hourlySupplyRaw || !this.hourlySupplyRaw.rows || !this.hourlySupplyRaw.rows.length) {
        return [];
      }

      var row = this.hourlySupplyRaw.rows[0];
      var weeksMeta = this.hourlySupplyRaw.weeks || [];

      if (this.selectedWeeks && this.selectedWeeks.length) {
        var selectedWeekNums = this.weeksToNumbers(this.selectedWeeks);

        return (row.weekly || [])
          .filter((wk) => selectedWeekNums.indexOf(wk.week) !== -1)
          .map((wk) => {
            var meta = weeksMeta.find(function (w) { return w.week === wk.week; });
            return {
              circle: row.circle_name,
              week: 'Week ' + wk.week,
              from_date: meta ? this.formatDateDMY(meta.from_date) : '',
              to_date: meta ? this.formatDateDMY(meta.to_date) : '',
              combined: wk.combined
            };
          });
      }

      return [{
        circle: row.circle_name,
        month: row.month,
        combined: row.monthly.combined
      }];
    },

    hourlySupplyFieldsComputed() {
      if (this.selectedWeeks && this.selectedWeeks.length) {
        return [
          { key: 'circle', label: 'Circle', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
          { key: 'week', label: 'Week', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
          { key: 'from_date', label: 'From', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
          { key: 'to_date', label: 'To', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
          { key: 'combined', label: 'Hours of Supply', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
        ];
      }
      return [
        { key: 'circle', label: 'Circle', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'month', label: 'Month', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'combined', label: 'Hours of Supply', thStyle: { backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ];
    },

    saidiSaifiData() {
      if (!this.saidiSaifiRaw) {
        return [];
      }

      var raw = this.saidiSaifiRaw;
      var circleId = this.selectedCircle;

      var saidiEntry = ((raw.saidi && raw.saidi.combined) || []).find(function (r) { return r.circle_id === circleId; });
      var saifiEntry = ((raw.saifi && raw.saifi.combined) || []).find(function (r) { return r.circle_id === circleId; });

      if (!saidiEntry) {
        return [];
      }

      return [{
        circle: saidiEntry.circle_name,
        month: raw.month_name,
        saidi: saidiEntry.saidi_minutes,
        saifi: saifiEntry ? saifiEntry.saifi : null
      }];
    },

    selectedCircleName() {
      var opt = this.circleOptions.find((o) => o.value === this.selectedCircle);
      return opt ? opt.text : '';
    },

    selectedMonthLabel() {
      var opt = this.monthOptions.find((o) => o.value === this.selectedMonth);
      return opt ? opt.text : '';
    }
  },

  watch: {
    selectedCircle(newVal) {
      if (!newVal) {
        this.selectedYear = null;
        this.selectedMonth = null;
        this.selectedWeeks = [];
      }
      this.fetchActiveTab(false);
    },
    selectedYear(newVal) {
      if (!newVal) {
        this.selectedMonth = null;
        this.selectedWeeks = [];
      }
      this.fetchActiveTab(false);
    },
    selectedMonth(newVal) {
      if (!newVal) {
        this.selectedWeeks = [];
      }
      this.fetchActiveTab(false);
    }
  },

  methods: {

    hasRequiredSelected() {
      return !!(this.selectedCircle && this.selectedYear && this.selectedMonth);
    },

    fetchActiveTab(showAlertIfInvalid) {
      if (!this.hasRequiredSelected()) {
        if (showAlertIfInvalid) {
          this.validateRequired();
        }
        return;
      }

      if (this.activeTabIndex === 0) {
        this.fetchHourlySupply();
      } else {
        this.fetchSaidiSaifi();
      }
    },

    validateRequired() {
      if (!this.selectedCircle) {
        this.alertMsg = 'Please select a Circle.';
        this.$bvModal.show('circleSupplyAlertModal');
        return false;
      }
      if (!this.selectedYear) {
        this.alertMsg = 'Please select a Year.';
        this.$bvModal.show('circleSupplyAlertModal');
        return false;
      }
      if (!this.selectedMonth) {
        this.alertMsg = 'Please select a Month.';
        this.$bvModal.show('circleSupplyAlertModal');
        return false;
      }
      return true;
    },

    weeksToNumbers(weeks) {
      return weeks.map(function (w) {
        var m = /\d+/.exec(w);
        return m ? parseInt(m[0], 10) : null;
      });
    },

    formatDateDMY(isoDateStr) {
      if (!isoDateStr) {
        return '';
      }
      var parts = isoDateStr.split('-');
      if (parts.length !== 3) {
        return isoDateStr;
      }
      return parts[2] + '-' + parts[1] + '-' + parts[0];
    },

    onTabActivate(newTabIndex, prevTabIndex, event) {

      if (!this.validateRequired()) {
        if (event) {
          event.preventDefault();
        }
        return;
      }

      this.selectedWeeks = [];

      if (newTabIndex === 0) {
        this.fetchHourlySupply();
      } else if (newTabIndex === 1) {
        this.fetchSaidiSaifi();
      }
    },

    fetchHourlySupply() {
      var parent = this;
      parent.show = true;

      axios.get(this.$urlCommon + '/api/web/eodb/hours-of-supply', {
        params: {
          year: this.selectedYear,
          month: parseInt(this.selectedMonth, 10),
          circle_id: this.selectedCircle
        }
      }).then((response) => {
        parent.show = false;
        parent.hourlyLoaded = true;
        parent.hourlySupplyRaw = response.data;
      }).catch((error) => {
        console.error('Error fetching hours of supply:', error);
        parent.show = false;
        parent.hourlyLoaded = true;
        parent.hourlySupplyRaw = null;
        parent.alertMsg = 'Sorry, please try again later.';
        parent.$bvModal.show('circleSupplyAlertModal');
      });
    },

    fetchSaidiSaifi() {
      var parent = this;
      parent.show = true;

      axios.get(this.$urlCommon + '/api/web/eodb/saidi-saifi', {
        params: {
          year: this.selectedYear,
          month: parseInt(this.selectedMonth, 10),
          circle_id: this.selectedCircle
        }
      }).then((response) => {
        parent.show = false;
        parent.saidiSaifiLoaded = true;
        parent.saidiSaifiRaw = response.data;
      }).catch((error) => {
        console.error('Error fetching SAIDI/SAIFI:', error);
        parent.show = false;
        parent.saidiSaifiLoaded = true;
        parent.saidiSaifiRaw = null;
        parent.alertMsg = 'Sorry, please try again later.';
        parent.$bvModal.show('circleSupplyAlertModal');
      });
    }
  }
}
</script>

<style scoped="true">

/deep/ .table > tbody > tr > td {
  font-size: 0.8rem;
  font-weight: 600;
}

.title {
  color: #1976d2;
  font-size: 1.5rem;
  font-weight: 600;
  text-transform: none !important;
}

.fieldLabel {
  color: #0d47a1;
  font-weight: bold;
}

.reqStar {
  color: #d32f2f;
}

.noData {
  text-align: center;
  font-size: larger;
  color: #9F3A22;
  padding: 2rem 0;
}

.data {
  font-weight: 600;
  color: #ff5722;
  font-size: 1.2rem;
}

hr {
  margin-top: 5px;
  margin-bottom: 5px;
}

.headerF {
  display: block;
}
.headerM {
  display: none;
}

.paddingLeft30px {
  padding-left: 30px;
}

.dorpDownMarginTop {
  margin-top: -16px;
}

.alignAndPadding {
  text-align: right;
  padding-right: 0;
}

.weekChecks >>> .custom-control {
  margin-right: 1rem;
  display: inline-block;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }
  .headerM {
    display: block;
  }
  .paddingLeft30px {
    padding-left: 0px;
  }
  .dorpDownMarginTop {
    margin-top: 0;
  }
  .alignAndPadding {
    text-align: left;
    margin-top: 12px;
  }
}

</style>